import React, {
  useRef,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { Card } from '@makeably/creativex-design-system';
import VideoControls from 'components/molecules/VideoControls';
import styles from './SafeZone.module.css';

const propTypes = {
  creativeUrl: PropTypes.string.isRequired,
  isVideo: PropTypes.bool.isRequired,
  templateUrl: PropTypes.string.isRequired,
};

const TEMPLATE_PADDING = 300;

function SafeZone({
  creativeUrl,
  isVideo,
  templateUrl,
}) {
  const templateRef = useRef(null);
  const videoRef = useRef(null);
  const [assetStyle, setAssetStyle] = useState({});

  if (!templateUrl) return null;

  const handleTemplateLoad = () => {
    const xRatio = TEMPLATE_PADDING / templateRef.current?.naturalWidth;
    const yRatio = TEMPLATE_PADDING / templateRef.current?.naturalHeight;
    const xPercentage = `${100 * xRatio}%`;
    const yPercentage = `${100 * yRatio}%`;

    setAssetStyle({
      bottom: yPercentage,
      left: xPercentage,
      right: xPercentage,
      top: yPercentage,
    });
  };

  return (
    <Card>
      { isVideo && (
        <div className={styles.controls}>
          <VideoControls videoRef={videoRef} />
        </div>
      ) }
      <div className={styles.content}>
        <img
          ref={templateRef}
          alt="safe zone template"
          className={styles.overlay}
          src={templateUrl}
          onLoad={handleTemplateLoad}
        />
        <img
          alt="safe zone template"
          className={styles.template}
          src={templateUrl}
        />
        <div className={styles.assetContainer} style={assetStyle}>
          { !isVideo && (
            <img
              alt="asset"
              className={styles.asset}
              src={creativeUrl}
            />
          ) }
          { isVideo && (
            <video
              ref={videoRef}
              className={styles.asset}
              src={creativeUrl}
            />
          ) }
        </div>
      </div>
    </Card>
  );
}

SafeZone.propTypes = propTypes;

export default SafeZone;
